import { Controller } from '@hotwired/stimulus';
import { first } from 'lodash';
import { doc } from 'prettier';
import { throttle } from 'throttle-debounce';

export default class extends Controller {
	static targets = ['dropdownContainer', 'dropdownLink', 'dropdownMenu', 'menuBar'];

	initialize() {
		this.oldScrollValue = 0;
	}

	connect() {
		const navDesktop = document.querySelector('#navigation-desktop');

		document.addEventListener('scroll', () => this.closeAllDropdowns());

		document.addEventListener('click', (e) => {
			this.closeDropdownsOnDocumentClick(e);
		});
		//create new instance with callback for navigation. Checks if fully visible + 500px
		const observer = new IntersectionObserver(this.handleStickyNav.bind(this), {
			threshold: 1.0,
			rootMargin: '500px',
		});

		observer.observe(navDesktop);
	}

	handleStickyNav(entries) {
		const stickyBar = document.querySelector('#navigation-sticky-bar');

		entries.map((entry) => {
			///show sticky bar if navbar is not visible anymore
			if (!entry.isIntersecting && stickyBar.classList.contains('lg:hidden')) {
				changeElementStatus('scrolling-down');
			}
			///hide sticky bar 500 px before normal nav is visible
			if (entry.isIntersecting && stickyBar.classList.contains('lg:block')) {
				changeElementStatus('scrolling-up');
			}
		});

		///changes status from and to Sticky nav
		function changeElementStatus(status) {
			if (status === 'scrolling-down') {
				stickyBar.classList.remove('lg:hidden');
				stickyBar.classList.add('lg:block');

				//timeout for animation
				setTimeout(function () {
					stickyBar.classList.remove('lg:-translate-y-full');
				}, 200);
			}
			if (status === 'scrolling-up') {
				stickyBar.classList.add('lg:-translate-y-full');

				//timeout for animation on scrolling up
				setTimeout(function () {
					stickyBar.classList.remove('lg:block');
					stickyBar.classList.add('lg:hidden');
				}, 200);
			}
		}
	}

	toggleDropdown(e) {
		e.preventDefault();

		const dropdownContainer = e.currentTarget.closest('[data-navigation-desktop-target="dropdownContainer"');
		//style fix, sticky dropdown
		if (dropdownContainer.closest('#navigation-sticky-bar')) {
			dropdownContainer.querySelector('#accommodation').classList.remove('top-[90%]');
			dropdownContainer.querySelector('#accommodation').classList.add('top-[110%]');
		}
		if (dropdownContainer.closest('#navigation-desktop')) {
			dropdownContainer.querySelector('#accommodation').classList.remove('top-[110%]');
			dropdownContainer.querySelector('#accommodation').classList.add('top-[90%]');
		}

		if (dropdownContainer.hasAttribute('data-group-active')) {
			dropdownContainer.removeAttribute('data-group-active');
		} else {
			this.closeAllDropdowns();
			dropdownContainer.setAttribute('data-group-active', true);
		}
	}

	closeAllDropdowns() {
		this.dropdownContainerTargets.forEach((dropdownContainerTarget) => {
			dropdownContainerTarget.removeAttribute('data-group-active');
		});
	}

	closeDropdownsOnDocumentClick(e) {
		if (
			!this.dropdownMenuTargets.includes(e.target) &&
			!this.dropdownMenuTargets.includes(e.target.closest('[data-navigation-desktop-target="dropdownMenu"]')) &&
			!this.dropdownLinkTargets.includes(e.target) &&
			!this.dropdownLinkTargets.includes(e.target.closest('[data-navigation-desktop-target="dropdownLink"]'))
		) {
			this.closeAllDropdowns();
		}
	}
}
